<template>
    <CRow>
      <CCol col="12" xl="12">
        <transition name="slide">
        <CCard>
          <CCardHeader>
            <h4>Τιμολόγια</h4>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              pagination
              @pagination-change="changeItemsLimit"
              column-filter
              table-filter
              :items-per-page-select='{ label: "Τιμολόγια ανά σελίδα:" }'
              hover
              :loading="loading"
              sorter
            >

            <template #consultant="{item}">
            <td>
              {{ item.consultant === null ? '' : item.consultant }}
            </td>
          </template>

          <!-- <template #signed_deal="{item}">
            <td>
              <div class="" style="color: green;" v-if="item.signed_deal == true">Υπογραφή</div>
              <div class="" style="color: blue;" v-else>Σύμβαση</div>
            </td>
          </template> -->



          <template #complex="{item}">
            <td>
              <div v-if="item.complex != 0 && item.complex_payment_status != null" :style="priceColor(item.complex_payment_status)">
                {{ item.complex }}
              </div>
              <div v-else></div>
            </td>
          </template>
          <template #special_inspection="{item}">
            <td>
              <!-- {{ item.special_inspection === 0 ? '' : item.special_inspection }} -->
              <div v-if="item.special_inspection != 0 && item.special_payment_status != null" :style="priceColor(item.special_payment_status)">
                {{ item.special_inspection }}
              </div>
              <div v-else></div>
            </td>
          </template>
          <template #start_inspection="{item}">
            <td>
              <div v-if="item.start_inspection != 0 && item.payment_statuses.start_inspection != null" :style="priceColor(item.payment_statuses.start_inspection)"  >{{ item.start_inspection }}</div>
              <div v-else></div>
            </td>
          </template>
          <template #first_inspection="{item}">
            <td>
              <div v-if="item.first_inspection != 0 && item.payment_statuses.first_inspection != null" :style="priceColor(item.payment_statuses.first_inspection)"  >{{ item.first_inspection }}</div>
              <div v-else></div>
            </td>
          </template>
          <template #second_inspection="{item}">
            <td>
              <div v-if="item.second_inspection != 0 && item.payment_statuses.second_inspection != null" :style="priceColor(item.payment_statuses.second_inspection)"  >{{ item.second_inspection }}</div>
              <div v-else></div>
            </td>
          </template>
          <template #re_inspection="{item}">
            <td>
              <div v-if="item.re_inspection != 0 && item.payment_statuses.re_inspection != null" :style="priceColor(item.payment_statuses.re_inspection)"  >{{ item.re_inspection }}</div>
              <div v-else></div>
            </td>
          </template>
          <template #first_inspection_no2="{item}">
            <td>
              <div v-if="item.first_inspection_no2 != 0 && item.payment_statuses.first_inspection_no2 != null" :style="priceColor(item.payment_statuses.first_inspection_no2)"  >{{ item.first_inspection_no2 }}</div>
              <div v-else></div>
            </td>
          </template>
          <template #second_inspection_no2="{item}">
            <td>
              <div v-if="item.second_inspection_no2 != 0 && item.payment_statuses.second_inspection_no2 != null" :style="priceColor(item.payment_statuses.second_inspection_no2)"  >{{ item.second_inspection_no2 }}</div>
              <div v-else></div>
            </td>
          </template>
          <!-- <template #re_inspection_no2="{item}">
            <td>
              <div v-if="item.re_inspection_no2 != 0 && item.payment_statuses.re_inspection_no2 != null" :style="priceColor(item.payment_statuses.re_inspection_no2)"  >{{ item.re_inspection_no2 }}</div>
              <div v-else></div>
            </td>
          </template>
          > -->

          <template #notes="{item}">
            <td>
              {{ item.notes === null ? '' : item.notes }}
            </td>
          </template>

          </CDataTable>
          </CCardBody>
        </CCard>
        </transition>
      </CCol>
    </CRow>
  </template>

  <script>
  import axios from 'axios'

  const fields = [
    {
      key: 'document_numbers',
      label: 'No.',
      sorter: false,
      filter: true
    },
    {
      key: 'company',
      label: 'Πελάτης',
      sorter: true,
      filter: true
    },
    {
      key: 'consultant',
      label: 'Σύμβουλος',
      sorter: true,
      filter: true
    },
    {
      key: 'services',
      label: 'Πρότυπο',
      sorter: true,
      filter: true
    },
    // {
    //   key: 'signed_deal',
    //   label: 'Κατάσταση',
    //   sorter: true,
    //   filter: true
    // },
    {
      key: 'is_revoked',
      label: 'Ανακληθεί',
      sorter: true,
      filter: true
    },
    {
      key: 'complex',
      label: 'Complex',
      sorter: true,
      filter: true
    },
    {
      key: 'special_inspection',
      label: 'Ειδική επιθεώρηση',
      sorter: true,
      filter: true
    },
    {
      key: 'start_inspection',
      label: 'Αρχική',
      sorter: true,
      filter: true
    },
    {
      key: 'first_inspection',
      label: '1η επιτήρηση',
      sorter: true,
      filter: true
    },
    {
      key: 'second_inspection',
      label: '2η επιτήρηση',
      sorter: true,
      filter: true
    },
    {
      key: 're_inspection',
      label: 'Επαναπιστοποίηση',
      sorter: true,
      filter: true
    },
    {
      key: 'first_inspection_no2',
      label: '1η επιτήρηση_no2',
      sorter: true,
      filter: true
    },
    {
      key: 'second_inspection_no2',
      label: '2η επιτήρηση_no2',
      sorter: true,
      filter: true
    },
    // {
    //   key: 're_inspection_no2',
    //   label: 'Επαναπιστοποίηση_no2',
    //   sorter: true,
    //   filter: true
    // },
    {
      key: 'notes',
      label: 'Σχόλια',
      sorter: true,
      filter: true
    },
  ]

  export default {
    name: 'InvoicesDashboard',
    data: () => {
      return {
        items: [],
        fields,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        loading: true,
      }
    },
    paginationProps: {
      align: 'center',
      doubleArrows: false,
      previousButtonHtml: 'prev',
      nextButtonHtml: 'next'
    },
    computed: {
      filteredItems() {
       return this.items;
      }
    },
    methods: {
      getData (){
        let self = this;
        axios.get('/api/invoice/dashboard?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
            self.items = response.data;
            self.loading = false;
        }).catch(function (error) {
          console.log(error);
          self.loading = false;
          self.$router.push({ path: '/login' });
        });
      },
      changeItemsLimit( val ){
        console.log('Run!');
        console.log(val);
        this.perPage = val;
      },
      priceColor(status) {
        if (status == 0) {
          return { "color": "red" }
        } else if (status == 1) {
          return { "color": "#D6B85A" }
        } else if (status == 2) {
          return { "color": "green" }
        } else if (status == 3) {
          return { "color": "orange" }
        } else {
          return { "color": "black" }
        }

      }
    },
    mounted: function(){
      this.getData();
    }
  }
  </script>
